// Shared PWA install state. Captures the browser's beforeinstallprompt event
// and exposes it to anywhere in the app that wants to trigger install.
//
// Usage:
//   import { triggerInstall, canInstall, isIOS, isStandalone } from "../lib/install";
//   if (canInstall()) triggerInstall();

let _deferredPrompt = null;
const _listeners = new Set();

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    _deferredPrompt = e;
    _listeners.forEach((cb) => cb(true));
  });
  window.addEventListener("appinstalled", () => {
    _deferredPrompt = null;
    _listeners.forEach((cb) => cb(false));
  });
}

export const canInstall = () => Boolean(_deferredPrompt);

export const isStandalone = () => {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
};

export const isIOS = () => {
  if (typeof navigator === "undefined") return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

export const isMobile = () => {
  if (typeof navigator === "undefined") return false;
  return /android|iphone|ipad|ipod|mobile/i.test(navigator.userAgent);
};

export const triggerInstall = async () => {
  if (!_deferredPrompt) return { outcome: "unavailable" };
  try {
    _deferredPrompt.prompt();
    const choice = await _deferredPrompt.userChoice;
    _deferredPrompt = null;
    _listeners.forEach((cb) => cb(false));
    return { outcome: choice.outcome }; // "accepted" | "dismissed"
  } catch {
    return { outcome: "error" };
  }
};

export const onInstallAvailabilityChange = (callback) => {
  _listeners.add(callback);
  // Fire immediately with current state
  callback(canInstall());
  return () => _listeners.delete(callback);
};
